module.exports = __webpack_public_path__ + "static/img/guan7.cc16b40.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan7.jpeg
// module id = wepK
// module chunks = 36